import PropTypes from "prop-types"

import Image from "components/ui/image"

const Placeholder = ({ dataCy, index }) => {
  return (
    <li className="relative" data-cy={dataCy}>
      <Image
        alt=""
        className="shimmer tablet:max-w-256 widescreen:max-w-300 mx-auto block h-auto w-full max-w-full"
        height="1024"
        src={require(
          `images/collections/placeholder_masks/ring_${(index % 6) + 1}.svg`
        )}
        width="1024"
      />
    </li>
  )
}

Placeholder.propTypes = {
  dataCy: PropTypes.string,
  index: PropTypes.number,
}

export default Placeholder
